import React from "react";

// @mui component
import type { PaperProps } from "@mui/material/Paper";
import XPaper from "@mui/material/Paper";

const Paper: React.FC<PaperProps> = (props) => {
  return <XPaper {...props}>{props.children}</XPaper>;
};

export default Paper;
